if (!customElements.get('variant-image-switcher')) {
  class VariantImageSwitcher extends HTMLElement {
    connectedCallback() {
      this.selectedSize = 'off';
      this.originalImages = new WeakMap();
      this.appliedPhotos = new WeakMap();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-size]');
        if (!button) return;
        this.selectedSize = button.dataset.size;
        this.querySelectorAll('button').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        this.updateImages();
      }, options);
      document.addEventListener('on:facet-filters:updated', () => this.updateImages(), options);
      // Infinite scrolling adds cards without recreating the drawer.
      this.results = this.closest('.shopify-section')?.querySelector('#filter-results');
      if (this.results) {
        this.observer = new MutationObserver(() => this.updateImages());
        this.observer.observe(this.results, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    updateImages() {
      const scope = this.results || document;
      scope.querySelectorAll('[data-ap-product-card], .card--product').forEach((card) => {
        const image = card.querySelector('.ap-product-card__media-image, .card__main-image');
        if (!image) return;
        const key = this.selectedSize === 'regular' ? 'smallImage' : 'largeImage';
        const photo = this.selectedSize === 'off' ? null : card.dataset['photo' + (this.selectedSize === 'regular' ? 'Regular' : 'Large')] || card.dataset[key] || null;
        if (this.appliedPhotos.get(card) === photo) return;
        if (!photo && !card.classList.contains('ap-product-card--photo-preview')) return;
        if (!this.originalImages.has(image)) {
          this.originalImages.set(image, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') });
        }
        const original = this.originalImages.get(image);
        if (photo) {
          const url = new URL(photo, window.location.href);
          const srcset = [400, 600, 800, 1200].map((width) => {
            const candidate = new URL(url);
            candidate.searchParams.set('width', width);
            return candidate.href + ' ' + width + 'w';
          }).join(', ');
          image.src = url.href;
          image.srcset = srcset;
        } else {
          image.setAttribute('src', original.src);
          if (original.srcset) image.setAttribute('srcset', original.srcset);
          else image.removeAttribute('srcset');
        }
        card.classList.toggle('ap-product-card--photo-preview', !!photo);
        this.appliedPhotos.set(card, photo);
        card.dispatchEvent(new CustomEvent('ap:photo-preview'));
      });
    }
  }
  customElements.define('variant-image-switcher', VariantImageSwitcher);
}
